import { render, staticRenderFns } from "./CMSEdit.vue?vue&type=template&id=5afc4802&"
import script from "./CMSEdit.vue?vue&type=script&lang=js&"
export * from "./CMSEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports